import AdminUsers from './AdminUsers.jsx';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import { request as queryUsers } from '../../modules/staff/actions/query';
import { request as updateUser } from '../../modules/staff/actions/update';
import { request as getPermissions } from '../../modules/permissions/actions/get';
import { request as getRoles } from '../../modules/roles/actions/get';

import decorate from '../../utils/decorate';

const STATE_KEY = 'admin-user';

function mapStateToProps(state) {
    return {
        users: state.staff.getIn([ 'items' ], Map()),
        roles: state.roles.getIn([ 'items' ], Map()).filter(role => (
            state.roles.getIn([ 'collections', 'staff' ]).contains(role.get('id'))
        )),
        permissions: state.permissions.getIn([ 'items' ], Map()),
        loading: (
            state.roles.get('state') === 'IN_PROGRESS' ||
            state.permissions.get('state') === 'IN_PROGRESS' ||
            state.staff.get('state') === 'IN_PROGRESS'
        )
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onUserQueryRequest: q => dispatch(queryUsers(q)),
        onPermissionsGetRequest: () => dispatch(getPermissions()),
        onRolesGetRequest: () => dispatch(getRoles()),
        onUserUpdateRequest: (id, userData) => dispatch(updateUser(id, userData))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AdminUsers
);
